interface EventUserInvitationDetails {
  id: string;
  title: string;
  start_date: string;
  start_time: string;
  end_date?: string;
  end_time?: string;
  location?: string;
  host_name: string;
  image_url?: string;
  invitation_token: string;
  is_on_waiting_list?: boolean;
  waiting_list_position?: number;
  custom_message?: string;
  base_url: string;
}

export function getEventUserInvitationTemplate(event: EventUserInvitationDetails) {
  const acceptUrl = `${event.base_url}/events/${event.id}/accept?token=${event.invitation_token}`;
  
  const subject = `Estás invitado a ${event.title}`;
  
  const formattedDate = new Date(event.start_date).toLocaleDateString('es-AR', {
    weekday: 'long', 
    month: 'long', 
    day: 'numeric',
    year: 'numeric'
  });
  
  const body = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
      <style>
        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
          line-height: 1.6;
          color: #1f2937;
          margin: 0;
          padding: 0;
          background: linear-gradient(135deg, #e0f2fe 0%, #fff9c4 35%, #dcfce7 100%);
          min-height: 100vh;
        }
        .email-container {
          max-width: 600px;
          margin: 40px auto;
          background-color: #ffffff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .header {
          background: linear-gradient(135deg, #e0f2fe 0%, #fff9c4 35%, #dcfce7 100%);
          padding: 40px 30px;
          text-align: center;
        }
        .header h1 {
          margin: 0;
          color: #1f2937;
          font-size: 28px;
          font-weight: 700;
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .header .subtitle {
          margin-top: 8px;
          color: #6b7280;
          font-size: 16px;
          font-weight: 400;
        }
        .content {
          padding: 40px 30px;
        }
        .event-image {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 8px;
          margin-bottom: 24px;
        }
        h2 {
          color: #1f2937;
          margin: 0 0 16px 0;
          font-size: 24px;
          font-weight: 600;
        }
        .custom-message {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border-left: 4px solid #3b82f6;
          padding: 20px;
          border-radius: 8px;
          margin: 24px 0;
        }
        .custom-message h3 {
          margin: 0 0 8px 0;
          color: #1f2937;
          font-size: 16px;
          font-weight: 600;
        }
        .custom-message p {
          margin: 0;
          color: #4b5563;
          font-style: italic;
        }
        .event-details {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          padding: 24px;
          border-radius: 8px;
          margin: 24px 0;
          border: 1px solid #e5e7eb;
        }
        .detail-row {
          display: flex;
          margin-bottom: 12px;
          align-items: center;
        }
        .detail-row:last-child {
          margin-bottom: 0;
        }
        .detail-icon {
          width: 20px;
          height: 20px;
          margin-right: 12px;
          color: #6b7280;
        }
        .detail-label {
          width: 80px;
          font-weight: 600;
          color: #374151;
          font-size: 14px;
        }
        .detail-value {
          flex: 1;
          color: #1f2937;
          font-size: 14px;
        }
        .waiting-list-notice {
          background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
          border: 1px solid #f59e0b;
          border-radius: 8px;
          padding: 20px;
          margin: 24px 0;
          text-align: center;
        }
        .waiting-list-notice h3 {
          margin: 0 0 8px 0;
          color: #92400e;
          font-size: 18px;
          font-weight: 600;
        }
        .waiting-list-notice p {
          margin: 0;
          color: #b45309;
          font-size: 14px;
        }
        .position-badge {
          display: inline-block;
          background: #f59e0b;
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-weight: 600;
          font-size: 14px;
          margin-top: 8px;
        }
        .cta-button {
          display: inline-block;
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          color: white !important;
          text-decoration: none;
          padding: 16px 32px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 16px;
          margin-top: 24px;
          text-align: center;
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
          transition: all 0.2s ease;
        }
        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
        }
        .secondary-info {
          margin-top: 24px;
          padding: 16px;
          background: #f9fafb;
          border-radius: 6px;
          font-size: 14px;
          color: #6b7280;
          text-align: center;
        }
        .footer {
          padding: 24px 30px;
          text-align: center;
          font-size: 12px;
          color: #9ca3af;
          border-top: 1px solid #e5e7eb;
          background: #f9fafb;
        }
        .footer a {
          color: #3b82f6;
          text-decoration: none;
        }
        .logo {
          font-size: 24px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 8px;
        }
        @media only screen and (max-width: 600px) {
          .email-container {
            margin: 20px;
            border-radius: 8px;
          }
          .header, .content {
            padding: 24px 20px;
          }
          .detail-row {
            flex-direction: column;
            align-items: flex-start;
          }
          .detail-label {
            width: 100%;
            margin-bottom: 4px;
          }
          .cta-button {
            width: 100%;
            box-sizing: border-box;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          <div class="logo">Punta Tech Meetup</div>
          <h1>¡Estás invitado!</h1>
          <div class="subtitle">Todo gran evento empieza con grandes personas</div>
        </div>
        
        <div class="content">
          <p>Hola,</p>
          <p><strong>${event.host_name}</strong> te invitó a participar de un gran evento:</p>
          
          ${event.image_url ? `<img src="${event.image_url}" alt="${event.title}" class="event-image">` : ''}
          
          <h2>${event.title}</h2>
          
          ${event.custom_message ? `
            <div class="custom-message">
              <h3>Mensaje de ${event.host_name}:</h3>
              <p>"${event.custom_message}"</p>
            </div>
          ` : ''}
          
          <div class="event-details">
            <div class="detail-row">
              <div class="detail-label">📅 Fecha:</div>
              <div class="detail-value">${formattedDate}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">🕐 Hora:</div>
              <div class="detail-value">${event.start_time}${event.end_time ? ` - ${event.end_time}` : ''}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">📍 Lugar:</div>
              <div class="detail-value">${event.location || 'Online'}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">👤 Anfitrión:</div>
              <div class="detail-value">${event.host_name}</div>
            </div>
          </div>
          
          ${event.is_on_waiting_list ? `
            <div class="waiting-list-notice">
              <h3>🎫 Estás en la lista de espera</h3>
              <p>Este evento tiene cupos limitados. Te avisaremos si se libera un lugar.</p>
              <div class="position-badge">Posición #${event.waiting_list_position}</div>
            </div>
          ` : ''}
          
          <center>
            <a href="${acceptUrl}" class="cta-button">
              ${event.is_on_waiting_list ? 'Unirme a la lista de espera' : 'Aceptar invitación'}
            </a>
          </center>
          
          <div class="secondary-info">
            <p>📱 Este enlace te llevará directo a la página del evento para confirmar asistencia y ver los detalles.</p>
            <p>¿No podés hacer clic? Copiá este enlace: <br><a href="${acceptUrl}" style="color: #3b82f6; word-break: break-all;">${acceptUrl}</a></p>
          </div>
        </div>
        
        <div class="footer">
          <p>Esta invitación fue enviada por <strong>Punta Tech Meetup</strong>.</p>
          <p>Si creés que recibiste este correo por error, ignoralo.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return { subject, body };
}